export const ACTIVATE_CLICK_ON_SEARCH_BAR = 'ACTIVATE_CLICK_ON_SEARCH_BAR'

export function clickOnSearchBarReducer (state = null, action) {
    switch (action.type){
        case ACTIVATE_CLICK_ON_SEARCH_BAR:
            return action.payload
        default: return state
    }
}